import React, { useReducer, createContext } from 'react';
import PropTypes from 'prop-types';

import reducer, { initialState } from './reducer';

export const RecordsContext = createContext();

function Records({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <RecordsContext.Provider value={{ state, dispatch }}>{React.Children.only(children)}</RecordsContext.Provider>;
}

Records.propTypes = {
  children: PropTypes.node,
};

export default Records;
